"use client";

import { ActiveAnalyticsProvider } from "./resolve-provider";

/** Stop the active provider capturing after analytics consent is revoked (no import from analytics barrel — avoids cycles). */
export function optOutAnalytics(): void {
	ActiveAnalyticsProvider.optOut?.();
}
